var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2581(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2581",
    "data-name": "Group 2581",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.82,
    height: 19.256,
    viewBox: "0 0 25.82 19.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M-498.867,189.3a3.248,3.248,0,0,1,.236-.312q5.878-5.882,11.759-11.761a1.294,1.294,0,0,1,1.727-.246,1.783,1.783,0,0,1,.247.213q.857.853,1.711,1.71a1.283,1.283,0,0,1,0,1.938q-7.357,7.36-14.718,14.718a1.287,1.287,0,0,1-1.957-.006q-4.117-4.115-8.232-8.232a1.291,1.291,0,0,1,0-1.991q.827-.83,1.657-1.657a1.294,1.294,0,0,1,1.992-.005q2.675,2.671,5.345,5.346C-499.037,189.084-498.984,189.161-498.867,189.3Z",
    transform: "translate(508.565 -176.756)",
    fill: "#f18181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2581);
export default __webpack_public_path__ + "static/media/Group 2581.b38bb6425acf8829582380247727ab84.svg";
export { ForwardRef as ReactComponent };